import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("gis_admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const SERVICES = [
  {
    slug: "nac",
    name: "Network Access Control",
    short: "Keycard, biometric & cloud-managed door access.",
    desc: "Secure every door with audited, role-based access. Keycards, mobile credentials, biometrics, visitor management, and cloud-managed admin.",
    image: "https://images.unsplash.com/photo-1702390796625-6dd9b46b1c0b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwxfHxzbWFydCUyMG9mZmljZSUyMHNlY3VyaXR5JTIwY2FtZXJhfGVufDB8fHx8MTc3NzUxNzc3NHww&ixlib=rb-4.1.0&q=85",
    icon: "ShieldCheck",
  },
  {
    slug: "av",
    name: "AV Systems",
    short: "Conference rooms, digital signage, sound masking.",
    desc: "Boardroom-grade A/V design and installation. Video conferencing, digital signage, distributed audio, and sound masking — engineered for clarity.",
    image: "https://images.pexels.com/photos/6949384/pexels-photo-6949384.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    icon: "MonitorPlay",
  },
  {
    slug: "cameras",
    name: "Security Cameras",
    short: "IP CCTV, NVR, AI-powered video analytics.",
    desc: "End-to-end IP surveillance with NVR storage, remote viewing, and AI analytics for intrusion, license plate, and people counting.",
    image: "https://images.unsplash.com/photo-1665655034566-d0f219bd23b3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHw0fHxzbWFydCUyMG9mZmljZSUyMHNlY3VyaXR5JTIwY2FtZXJhfGVufDB8fHx8MTc3NzUxNzc3NHww&ixlib=rb-4.1.0&q=85",
    icon: "Camera",
  },
  {
    slug: "cabling",
    name: "Structured Cabling",
    short: "Cat6/6A, fiber, & data center patch panels.",
    desc: "Certified, future-proof low-voltage cabling. Cat6/6A copper, single & multi-mode fiber, neat patch panels, and full BICSI documentation.",
    image: "https://images.pexels.com/photos/2881229/pexels-photo-2881229.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    icon: "Cable",
  },
];

export const HERO_IMAGE = "https://images.pexels.com/photos/6949382/pexels-photo-6949382.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";
export const GALLERY = [
  "https://images.pexels.com/photos/5073493/pexels-photo-5073493.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  "https://images.unsplash.com/photo-1680992044138-ce4864c2b962?crop=entropy&cs=srgb&fm=jpg",
  "https://images.unsplash.com/photo-1762176263996-a0713a49ee4d?crop=entropy&cs=srgb&fm=jpg",
];
